import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';

const ExampleCard = () => (
  <Col md={12}>
    <Card>
      <CardBody>
        <div className="card__title">
          <h5 className="bold-text">Informacion de la materias</h5>
          <h5 className="subhead">Facultad de Ingenieria</h5>
        </div>
        <p>materias...</p>
      </CardBody>
    </Card>
  </Col>
);

export default ExampleCard;
